import { Link as RouterLink } from 'react-router-dom';
import { experimentalStyled as styled } from '@material-ui/core/styles';
import { Card, Stack, Link, Container, Typography, Box } from '@material-ui/core';
import AuthLayout from '../layouts/AuthLayout';
import Page from '../components/Page';
import { MHidden } from '../components/@material-extend';
import { LoginForm } from '../components/authentication/login';
import AuthSocial from '../components/authentication/AuthSocial';

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex'
  }
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: 464,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  margin: theme.spacing(2, 0, 2, 2)
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 800,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(6, 0)
}));

export default function Login() {
  return (
    <RootStyle title="Login | ZIMTA">
      <Container maxWidth="sm">
        <ContentStyle>
          <Stack direction="column" alignItems="center" sx={{ mb: 2 }}>
            <Box
              component="img"
              src="/static/logo.png"
              sx={{ width: 120, height: 60, textAlign: 'center' }}
            />
          </Stack>
          <Stack sx={{ mb: 2, textAlign: 'center' }}>
            <Typography variant="h3" sx={{ color: '#0c5935' }} gutterBottom>
              Sign into ZIMAS
            </Typography>
            <Typography variant="h6" gutterBottom>
              (ZIMTA Membership Administration System)
            </Typography>
          </Stack>

          <LoginForm />

          <MHidden width="smUp">
            <Typography variant="body2" align="center" sx={{ mt: 3 }}>
              Don’t have an account?&nbsp;
              <Link variant="subtitle2" component={RouterLink} to="/register">
                Register
              </Link>
            </Typography>
          </MHidden>
        </ContentStyle>
      </Container>
    </RootStyle>
  );
}
